export const txts: string[] = [
  "Message aniobi anonymously",
  "Sharing our secrets is an act of courage.",
  "We are here to listen, not judge.",
  "Your secrets can't heal you but sharing them can.",
  "Your story inspires others, share it.",
  "Heavy hearts find light in shared words.",
  "Unspoken words can become toxic to your heart.",
];
